import React, { useCallback } from 'react';

import { updateOKR } from 'components/RabbitOKRCreationPanel/OKRCreationPanelSlice';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { okrCreationPanelStateSelector } from 'selectors/okrCreationPanelSelector';

import { OKR_PROGRESS_TYPES } from 'constants/ProjectConstants';

import { ManualTracking } from './ManualTracking';

interface Props {}

const TrackingSection = ({}: Props) => {
  const dispatch = useDispatch();

  const okrDetails = useSelector(okrCreationPanelStateSelector);
  const {
    measure,
    measureType,
    progressType = OKR_PROGRESS_TYPES.MANUAL,
    target,
    startingProgressValue,
    parentProgressType,
  } = okrDetails;

  const onChange = useCallback(
    (updates) => {
      dispatch(updateOKR(updates));
    },
    [dispatch]
  );

  return (
    <>
      {progressType === OKR_PROGRESS_TYPES.MANUAL ? (
        <ManualTracking
          measure={measure}
          measureType={measureType}
          startingProgressValue={startingProgressValue}
          target={target}
          onChange={onChange}
          parentProgressType={parentProgressType}
          isReadOnly={false}
        />
      ) : null}
    </>
  );
};

export { TrackingSection };
